// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"I3-z"};